import { ConvertedComponentData } from '../../../cms/components/types'
import { InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'

export interface TrainingLocationsComponentData extends ConvertedComponentData {
  trainingId?: string;
}

export const TRAINING_LOCATIONS_CONVERTER =
  new InjectionToken<Converter<CmsComponent, TrainingLocationsComponentData>[]>('TrainingLocationsConverter')
